// extracted by css-extract-rspack-plugin
export default {"loading":"src-modules-app-registry-templates-FullPageAppTemplate-components-AppLoader-AppLoader-module__loading-ahTlbC","spinner":"src-modules-app-registry-templates-FullPageAppTemplate-components-AppLoader-AppLoader-module__spinner-iRFUPg"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"loading\":\"src-modules-app-registry-templates-FullPageAppTemplate-components-AppLoader-AppLoader-module__loading-ahTlbC\",\"spinner\":\"src-modules-app-registry-templates-FullPageAppTemplate-components-AppLoader-AppLoader-module__spinner-iRFUPg\"}";
        // 1793873546920
        var cssReload = require("../../../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  